const STORAGE_KEY = 'zula-default-home-id';

/**
 * Reads the device-local "default home" choice made from the home card strip
 * on the Locations page (see issue #100). Same pattern as the theme
 * preference in ./theme.ts — a plain localStorage value, no backend involved,
 * since which home to land on is a per-device convenience, not account data.
 *
 * Returns null when nothing has been chosen yet, or the stored value is
 * corrupted/not a valid location id.
 */
export function getStoredDefaultHomeId(): number | null {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === null) return null;
  const id = Number(stored);
  return Number.isInteger(id) ? id : null;
}

/** Persists the user's chosen default home. */
export function setStoredDefaultHomeId(id: number): void {
  localStorage.setItem(STORAGE_KEY, String(id));
}
